// GENERATED CODE - DO NOT MODIFY BY HAND.
// Run: node ../scripts/syncCancellationFeedbackReasons.js

export const CANCELLATION_FEEDBACK_REASONS = [
  { id: "results", label: "Didn't see results" },
  { id: "price", label: "Too expensive" },
  { id: "bugs", label: "Too many bugs" },
  { id: "complex", label: "Too complicated to use" },
  { id: "alternative", label: "Found a better app" },
  { id: "features", label: "Not enough features" },
  { id: "break", label: "Just need a break" },
];

export const CANCELLATION_REASON_LABELS = {
  ...Object.fromEntries(
    CANCELLATION_FEEDBACK_REASONS.map(({ id, label }) => [id, label]),
  ),
  // Legacy review values kept for older stored responses.
  'Did not find what I needed': 'Did not find what I needed',
  'Too expensive': 'Too expensive',
  'Bugs or technical issues': 'Bugs or technical issues',
  'Not enough time to try': 'Not enough time to try',
  'I prefer another app': 'I prefer another app',
  Other: 'Other',
};

export function getReviewReasons(review) {
  if (Array.isArray(review?.reasons) && review.reasons.length > 0) {
    return review.reasons;
  }

  if (review?.reason) {
    return [review.reason];
  }

  if (Array.isArray(review?.options) && review.options.length > 0) {
    return review.options;
  }

  return [];
}

export function getReviewDetails(review) {
  return [
    review?.details,
    review?.followupAnswer,
    review?.feedback,
    review?.openFeedback,
  ].find((value) => String(value || '').trim()) || '';
}
